import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "main" }

import { onMounted } from 'vue'
import { useStorePuzzle } from './stores/puzzle'
import { useStoreQuizz } from './stores/quizz'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const quizzStore = useStoreQuizz()
const puzzleStore = useStorePuzzle()

onMounted(() => {
  quizzStore.init()
  puzzleStore.init()
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_view)
  ]))
}
}

})